import { useQuery } from '@tanstack/react-query';
import axios from '../utils/axios';

export interface ApiVersion {
  commit: string;
}

// GET /v1/version — commit the API is running (GIT_SHA baked into its Docker
// image). Public endpoint; the value can't change without a redeploy, so cache
// it for the session.
export function useApiVersion() {
  return useQuery({
    queryKey: ['api-version'],
    queryFn: async () => {
      const { data } = await axios.get<ApiVersion>('/v1/version');
      return data;
    },
    staleTime: Infinity,
    retry: false,
  });
}
